// extracted by mini-css-extract-plugin
export default {"header":"Navigation_header__OedbI","active":"Navigation_active__zGqmc","menuIcon":"Navigation_menuIcon__MD6Zp","navbarActive":"Navigation_navbarActive__Bfnq7"};